import React from 'react'
import { css } from '@emotion/react'
import { font } from 'plume-ui'

export const OneThousandYen: React.FC<{}> = () => {
  return (
    <span
      css={css`
        font-size: 11px;
        font-weight: ${font.weight.normal};
      `}
    >
      （千円）
    </span>
  )
}
